// components/ThemeListener.js
import React, { useEffect, useState } from 'react';
import { updateColors } from '../ColorConfig/colorconfig';

const ThemeListener = ({ children }) => {
  const [themeVersion, setThemeVersion] = useState(0);

  useEffect(() => {
    const handleThemeChange = () => {
      // Force re-render by updating state
      setThemeVersion(prev => prev + 1);
    };

    window.addEventListener('themeChanged', handleThemeChange);
    
    return () => {
      window.removeEventListener('themeChanged', handleThemeChange);
    };
  }, []);

  return <>{children}</>;
};

export default ThemeListener;